import React from "react";

const ReportHeader = ({ onBack, breadcrumbLabel, backButtonIcon }) => (
  <div className="dashboard-header" style={{ display: "flex", alignItems: "center", width: "100%" }}>
    <button
      type="button"
      className="merchant-detail-back-btn"
      onClick={onBack}
      style={{ display: "flex", alignItems: "center", gap: 8, background: "none", border: "none", padding: 0, cursor: "pointer" }}
    >
      <img src={backButtonIcon} alt="Back" style={{ width: 18, height: 18 }} />
      <span style={{ fontSize: 16, color: "#1E56A0", fontWeight: 600 }}>Dashboard</span>
    </button>
    <span style={{ marginLeft: 4, fontSize: 16, color: "#000000", fontWeight: 600 }}>&gt; {breadcrumbLabel}</span>
  </div>
);

export default ReportHeader;
